import { Component, Output, EventEmitter, Input, HostBinding } from '@angular/core';
import * as _ from 'lodash';

@Component({
    selector: 'app-search-bar',
    templateUrl: './search-bar.component.html',
    styleUrls: ['./search-bar.component.scss']
})
export class SearchBarComponent {
    @Input() input = '';
    @HostBinding('class.responsive') @Input() responsive = false;

    onInputChange = _.debounce(this.onSearch, 300);

    @Output() search = new EventEmitter<any>();
    @Output() click = new EventEmitter<any>();
    @Output() blur = new EventEmitter<any>();

    constructor() {
    }

    onSearch(value: string) {
        this.search.emit(value);
    }

    onClick() {
        this.click.emit();
    }

    onBlur() {
        this.blur.emit();
    }
}
